import { useState } from 'react'
import rest from '../../rest'
import { UserRelator } from './types'

const useStoreAtribuir = () => {
  const [store, _setStore] = useState<UserRelator[]>([])
  const [userDepartamento, _setUserDepartamento] = useState<UserRelator[]>([])
  const [error, setError] = useState<{ [index: string]: any }>({})
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState('')

  const clearError = () => {
    setError({})
    setSuccess('')
  }

  const checkLoading = (action: string) => {
    return loading === action
  }

  const checkError = (field: string) => {
    if (error[field]) {
      const fieldError = error[field]
      if (Array.isArray(fieldError)) {
        return fieldError[0]
      } else {
        return fieldError
      }
    } else {
      return null
    }
  }

  const add = (user: UserRelator) => {
    _setStore([...store, user])
  }

  const remove = (user: UserRelator) => {
    _setStore([...store.filter(e => e.key !== user.key)])
  }

  const list = async (idItemTrabalho: number, areasRelatoras: number[]) => {
    try {
      const arrayUsers = await Promise.all(
        areasRelatoras.map(area_relatora =>
          rest(
            `acl/usuarios-permitidos/add_reporteandamento/?area_relatora=${area_relatora}&itemtrabalho=${idItemTrabalho}`
          ).then(json => json.map((user: any) => ({ ...user, area_relatora })))
        )
      )
      const json = arrayUsers.reduce((p, c) =>
        [...p, ...c], []
      ).map((e: any) =>
        ({ key: `${e.id}-${e.area_relatora}`, ...e })
      )
      _setStore(json)
    } catch (e) {
      setError(e)
    }
  }

  const listUserDepartamento = async (areasRelatoras: number[]) => {
    const arrayUsers = await Promise.all(areasRelatoras.map(area_relatora =>
      rest(`acl/usuarios-permitidos/pode_ser_relator/?area_relatora=${area_relatora}`).then(json =>
        json.map((user: any) => ({ ...user, area_relatora }))
      )
    ))
    const json = arrayUsers.reduce((p, c) =>
      [...p, ...c], []
    ).map((e: any) =>
      ({ key: `${e.id}-${e.area_relatora}`, ...e })
    )
    _setUserDepartamento(json)
  }

  const save = async (idItemTrabalho: number, descricao: string | undefined, areasRelatoras: number[]) => {
    try {
      clearError()
      setLoading('save')
      const usuarios_por_departamento = areasRelatoras.map(area_relatora => ({
        usuarios: store.filter(
          e => e.area_relatora === area_relatora
        ).map(
          e => e.id
        ),
        departamento: area_relatora,
      }))
      const result = await rest(
        `tema-prioritario/${idItemTrabalho}/relatores/`,
        'PUT',
        { descricao, usuarios_por_departamento },
      )
      setSuccess(result.detail)
      setLoading('')
    } catch (e) {
      setError(e)
    }
  }
  const api = {
    add,
    remove,
    list,
    save,
    listUserDepartamento,
    checkError,
    checkLoading
  }

  return ({ store, success, userDepartamento, api })
}

export default useStoreAtribuir
